// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__aPXwN","infoBtn":"quickbooks_infoBtn__21ipO","formBox":"quickbooks_formBox__Jb2XH","formFooter":"quickbooks_formFooter__2lmkb"};